/**
 * Embedded game frame policy. The backend only serves embed URLs on an
 * approved https origin; this is a second, client-side check.
 *
 * sandbox: allow-scripts so the game can run; allow-same-origin so it keeps
 * its own origin (storage / cookies on the provider) — safe because the frame
 * is always a different origin from this app. No forms, popups, top
 * navigation, downloads or modals.
 */
export const EMBED_SANDBOX = "allow-scripts allow-same-origin";

export const EMBED_ALLOW = "fullscreen";

export const EMBED_REFERRER_POLICY = "strict-origin-when-cross-origin";

export const EMBED_LOAD_TIMEOUT_MS = 15000;

export const ASPECT_RATIOS = {
  "16:9": [16, 9],
  "4:3": [4, 3],
  "1:1": [1, 1],
  "3:4": [3, 4],
  "9:16": [9, 16],
};

export function isSafeEmbedUrl(url, appOrigin) {
  if (typeof url !== "string" || url.length > 2000) return false;
  if (/[^\x21-\x7e]|["'<>`\\]/.test(url)) return false;
  if (!/^https:\/\//i.test(url)) return false;
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:" || parsed.username || parsed.password) {
      return false;
    }
    if (appOrigin && parsed.origin === appOrigin) return false;
    return true;
  } catch (e) {
    return false;
  }
}

/** padding-top percentage for an aspect-ratio box. */
export function aspectPadding(ratio) {
  const pair = ASPECT_RATIOS[ratio] || ASPECT_RATIOS["16:9"];
  return (pair[1] / pair[0]) * 100;
}
